const title = '可达鸭教育'
const getTitle = function (tit) {
  let allTitle = tit + '-' + title
  return allTitle
}
export default getTitle
